<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <v-dialog v-model="dialog.role"
          @keydown.esc="dialog.role = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Ubah Hak Akses

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.role = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih Role" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Role
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Admin"

                      hide-details
                      
                      :items="role"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.role_id"
                      :success="form.role_id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="roles()"
                :loading="process.role"
                :disabled="process.role"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.role = false; dialog.fullscreen = false;"
                :disabled="process.role"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/user"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Pegawai
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="process.load && Object.keys(detail).length < 1"
                flat
                min-height="calc(100vh - 180px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div>
                      <v-img
                        contain
                        width="75"
                        height="75"
                        alt="kominfoklaten" 
                        :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
                        class="ma-auto"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <v-spacer />

                    <div
                      class="black--text text-right">
                      <div
                        class="title font-weight-bold line-text-first">
                        Pemerintah Kabupaten Klaten
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        Kabupaten Klaten | Klaten, Jawa Tengah 57424
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        0274-123456 | klatenkab@klaten.go.id
                      </div>
                    </div>
                  </div>

                  <v-divider
                    class="mt-4 mb-1"
                    style="border-top: 3px solid black;" />

                  <v-divider
                    style="border-top: 1px solid black;" />
                </v-card-text>
                
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2">
                      <v-skeleton-loader
                        class="ma-auto"
                        :loading="process.load"
                        type="image">
                      </v-skeleton-loader>
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="py-0">
                      <v-skeleton-loader
                        class="ma-auto"
                        :loading="process.load"
                        type="article, article">
                      </v-skeleton-loader>
                    </v-col>
                  </v-row>

                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="article, article, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line">
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat
                min-height="calc(100vh - 180px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div>
                      <v-img
                        contain
                        width="75"
                        height="75"
                        alt="kominfoklaten" 
                        :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
                        class="ma-auto"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <v-spacer />

                    <div
                      class="black--text text-right">
                      <div
                        class="title font-weight-bold line-text-first">
                        Pemerintah Kabupaten Klaten
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        Kabupaten Klaten | Klaten, Jawa Tengah 57424
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        0274-123456 | klatenkab@klaten.go.id
                      </div>
                    </div>
                  </div>

                  <v-divider
                    class="mt-4 mb-1"
                    style="border-top: 3px solid black;" />

                  <v-divider
                    style="border-top: 1px solid black;" />
                </v-card-text>

                <v-card-text
                  class="text-center px-8">
                  <v-divider
                    style="border-top: 1px solid black;" />

                  <div
                    class="body-1 font-weight-bold black--text my-1">
                    Data Pegawai
                  </div>

                  <v-divider
                    class="mb-4"
                    style="border-top: 1px solid black;" />
                  
                  <v-row
                    style="height: calc(100vh - 500px)">
                    <v-col
                      cols="12"
                      md="2">
                      <v-card
                        flat
                        width="100%"
                        height="175"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #EBEBEB; 
                              border-style: dashed;">
                        <v-img
                          contain
                          width="100%"
                          height="100%"
                          alt="kominfoklaten" 
                          :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member_default.png')"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-card>
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="font-weight-bold black--text pl-6">
                      <!-- <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Nomor Induk Pegawai
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left">
                          : {{ detail.nip }}
                        </v-col>
                      </v-row> -->

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Nama Lengkap
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left">
                          : {{ detail.name }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Email
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left">
                          : {{ detail.email }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Mobilephone
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left">
                          : {{ detail.mobilephone }}
                        </v-col>
                      </v-row>

                      <!-- <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Jenis Kelamin
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left">
                          : {{ detail.gender !== '' ? detail.gender : '-' }}
                        </v-col>
                      </v-row> -->

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Unit
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left text-capitalize">
                          : {{ detail.unit_title }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Role
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left text-capitalize">
                          : {{ detail.role }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Status
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left text-uppercase">
                          : {{ detail.is_active }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="3"
                          class="py-0 text-left">
                          Dibuat Tanggal
                        </v-col>

                        <v-col
                          cols="9"
                          class="py-0 text-left text-uppercase">
                          : {{ detail.create_datetime | date }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-divider
                    class="mt-6 mb-1"
                    style="border-top: 1px solid black;" />

                  <v-divider
                    style="border-top: 3px solid black;" />
                </v-card-text>
                
                <!-- <v-card-text
                  class="text-center px-8 pb-0">
                  <v-divider
                    style="border-top: 1px solid black;" />

                  <div
                    class="body-1 font-weight-bold black--text my-1">
                    Data Hak Akses
                  </div>

                  <v-divider
                    style="border-top: 1px solid black;" />
                </v-card-text> -->

                <!-- <v-card-text>
                  <v-treeview
                    dense
                    open-all
                    open-on-click

                    rounded
                    transition

                    :items="list"
                    item-key="id"
                    item-text="title"

                    item-children="sub_menu">
                    <template v-slot:prepend="{ item }">
                      <v-img v-if="item.icon !== undefined"
                        width="20"
                        height="20"
                        alt="kominfoklaten"  
                        :src="item.icon"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="18"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-icon v-else
                        size="18">
                        mdi-minus-thick
                      </v-icon>
                    </template>
                  </v-treeview>

                  <v-divider
                    class="mt-6 mb-1"
                    style="border-top: 1px solid black;" />

                  <v-divider
                    style="border-top: 3px solid black;" />
                </v-card-text> -->

                <v-card-actions
                  class="px-4 pb-5">
                  <v-spacer/>
                  
                  <v-btn 
                    :to="`/user/edit/${detail.id}`"
                    :disabled="process.form"
                    color="blue"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon size="20">mdi-circle-edit-outline</v-icon>

                    <span
                      class="ml-2">
                      Ubah Pegawai
                    </span>
                  </v-btn>

                  <v-btn 
                    @click="toRole(detail.id)"
                    :disabled="process.form"
                    color="green"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon size="20">mdi-menu-close</v-icon>

                    <span
                      class="ml-2">
                      Ubah Hak Akses
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,

          role: false
        },
        
        detail: {},

        role: [],

        list: [],

        form: {
          id: '',
          role_id: ''
        },
        
        process: {
          load: false,

          role: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      this.fetchDetail()
    },
    mounted () {
      
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/user/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data

            this.list = JSON.parse(this.detail.role_menu_arr)
          }
        })
      },

      async fetchRole () {
        await get('admin/menu_privilege/data')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.role = res.results.data
          }
        })
      },

      toRole (id) {
        this.form.id = id

        this.dialog.role = true

        this.fetchRole()
      },
      async roles () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.role = true

          await post(`admin/user/update_role`, {
            data: this.form
          }).then(response => {
            let res = response.data

            this.process.role = false

            if (res.status === 200) {

              this.dialog.role = false
              
              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>